var SETTINGS = {
    APP_VERSION: 1,
    LANGUAGE:    document.getElementById('site-ctn').getAttribute('data-lang'),
    BASE_URL:    window.location.protocol + "//" + window.location.host + "/",
    CURRENT_URL: window.location.protocol + "//" + window.location.host + window.location.pathname,
    API_URL:     null, // if needed
    CDN_URL:     null, // if needed
    VERSIONNING: new Date().getTime(), //for caching
    DEVICE:      "computer", // if needed
    IS_MOBILE:   false, // if needed
    IS_TABLET:   false, // if needed
    DEBUG_MODE:  false,  // turn false if you wanna disable console.
    RECAPTCHA: '6LeHV3wUAAAAADj_k1zC6wJmaGWjrS2w_B2hHaj8'
};

SETTINGS.ISIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

SETTINGS.BREAKPOINTS = {};
SETTINGS.BREAKPOINTS.XL_MIN     = 1440;
SETTINGS.BREAKPOINTS.LG_MAX     = SETTINGS.BREAKPOINTS.XL_MIN - 1;
SETTINGS.BREAKPOINTS.LG_MIN     = 1024;
SETTINGS.BREAKPOINTS.CUSTOMMENU_MAX     = SETTINGS.BREAKPOINTS.LG_MIN - 1;
SETTINGS.BREAKPOINTS.CUSTOMMENU_MIN     = 959;
SETTINGS.BREAKPOINTS.MD_MAX     = SETTINGS.BREAKPOINTS.CUSTOMMENU_MIN - 1;
SETTINGS.BREAKPOINTS.MD_MIN     = 768;
SETTINGS.BREAKPOINTS.SM_MAX     = SETTINGS.BREAKPOINTS.MD_MIN - 1;
SETTINGS.BREAKPOINTS.SM_MIN     = 480; 
SETTINGS.BREAKPOINTS.XS_MAX     = SETTINGS.BREAKPOINTS.SM_MIN - 1;

window.frenchRegex = /^[a-z ÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÒÓÔÕÖÙÚÛÜ àáâãäåæçèéêëìíîïòóôõöùúûü \-'’]*$/i;
